 <template id="template-section">
  <div class="border border-light p-3 pb-2 mb-1" v-if="!sectionData.isHidden">
    <!-- field header -->
    <!-- :class="isPreview ? 'p-3 text-left' : 'text-left'" -->
    <div
      :class="rightAlign ? 'text-right' : 'text-left'"
      v-if="(formTypeLocal == 1 || formTypeLocal == 9) && sectionData.advance && !sectionData.advance.hideSectionTitle"
    >
      <h3>
        <b-badge v-if="!rightAlign" variant="dark">{{(counter+1)}}</b-badge>
        &nbsp;{{sectionData.sectionTitle[selectedLanguage]}}
        <b-badge
          v-if="rightAlign && selectedLanguage == 'arabic'"
          variant="dark"
        >{{(new Intl.NumberFormat('ar-EG', { }).format(counter+1))}}</b-badge>
        <b-badge v-if="rightAlign && selectedLanguage == 'hebrew'" variant="dark">{{(counter+1)}}</b-badge>
      </h3>
      <br />
      <h5
        class="text-center"
      >{{sectionData.sectionSubTitle && sectionData.sectionSubTitle[selectedLanguage]}}</h5>
    </div>
    <ElementsContainer
      v-for="(fieldData, index) in sectionData.formElements"
      :key="index"
      :fieldData="fieldData"
      :isPreview="true"
      :isDisabled="isDisabled"
      :sectionIndex="sectionData.index"
      :fieldIndex="index"
      :inputType="fieldData.inputType"
    />
    <hr />
  </div>
</template>

<script>
import ElementsContainer from "../components/templatesConstants/elementIndex";
import uid from "uid";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
export default {
  name: "SectionUserContainer",
  components: {
    ElementsContainer,

    //Drop
  },
  data() {
    return {
      isHidden: false,
      condition: {},
      formTypeLocal: 0,
      collapse: true,
      sectionTitle: undefined,
      isRepeatable: 0,
    };
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage", "rightAlign"]),
    ...mapState(["rightAlign"]),
  },

  created() {
    // console.log("section data", this.sectionData.isHidden);
    EventBus.$on("sectionCheck", (value) => {
      if (value.id == this.sectionData.id) {
        // console.log("section data", value);
        this.sectionData.isHidden = value.isHidden;
        this.isHidden = value.isHidden;
        // this.form1.formSection[value.index].isHidden = value.isHidden;
      }
    });
  },
  //   watch:{
  // 	  sectionData(val){
  // 		console.log("asaa-watch", val)
  // 	  }
  //   },

  mounted() {
    // console.log("section user ---------------");
    // Object.assign(this.sectionData, (this.sectionData.isHidden = false));
    this.formTypeLocal = this.formType || this.$store.state.form1.formType;
    // this.isHidden = this.sectionData.isHidden
    //alert(this.sectionData.advance.hideSectionTitle);

    // this.sectionCondition();
  },

  methods: {
    ...mapActions([
      "setSectionIndex",
      "setfieldIndex",
      "repeatSectionContentStore",
    ]),

    ...mapMutations(["ADD_FIELD"]),

    sectionCondition() {
      // for section conditions
      let sections = this.form1.formSection;

      let indigenousSection1 = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] ==
          "Services/Goods (Additional Question)"
      );
      // console.log("indigenousSection 1", indigenousSection1);


      if (indigenousSection1) {
        let sec = this.form1.formSection[indigenousSection1.index];
        Object.assign(sec, (sec.isHidden = true));
         EventBus.$emit(
          "sectionCheck",
          this.form1.formSection[indigenousSection1.index]
        );
        this.form1.formSection[indigenousSection1.index].formElements.map(
          (ele) => {
            ele.validation.required = 0;
            ele.isInValid = false;
          }
        );
      } else {
        let sec = this.form1.formSection[indigenousSection1.index];
        Object.assign(sec, (sec.isHidden = false));
         EventBus.$emit(
          "sectionCheck",
          this.form1.formSection[indigenousSection1.index]
        );
        this.form1.formSection[indigenousSection1.index].formElements.map(
          (ele) => {
            ele.validation.required = 1;
          }
        );
        // this.form1.formSection[indigenousSection.index].isHidden = false;
      }
      console.log("")
    },

    onCloneSection(index, field) {
      let data = { index, field };
      this.repeatSectionContentStore(data);
    },

    clone(evt) {
      // console.log("clone-section", evt);
    },
  },
  props: {
    sectionData: Object,
    sectionIndex: Number,
    isPreview: Boolean,
    formType: Number,
    isDisabled: Number,
    counter: Number,
  },
};
</script>
<style scoped>
.section-preview {
  border: dashed 1px;
}
.section-height {
  min-height: 75px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
